<template>
  <vue-final-modal
    classes="flex justify-center items-center"
    v-model="modalVisible"
  >
    <div class="bg-white rounded-lg shadow-lg w-96 max-w-md mx-4">
      <div class="px-4 py-3 border-b border-gray-200">
        <h3 class="text-lg font-semibold text-gray-900">Delete version</h3>
        <p class="text-xs text-gray-500 mt-1">
          You are about to delete version
          <span class="font-medium">{{ version }}</span>.
          This version cannot be re-created with the same number later.
        </p>
      </div>

      <div class="px-4 py-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Reason for deletion <span class="text-gray-400 text-xs">(optional)</span>
        </label>
        <textarea
          :key="textareaKey"
          v-model.trim="deleteNote"
          rows="3"
          placeholder="Optional reason..."
          :disabled="submitting"
          class="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-red-500 disabled:bg-gray-50 disabled:cursor-not-allowed"
        ></textarea>
      </div>

      <div class="px-4 py-3 border-t border-gray-200 flex justify-end space-x-2">
        <button
          @click="handleCancel"
          :disabled="submitting"
          class="px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:hover:bg-gray-100 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
        <button
          @click="handleSubmit"
          :disabled="submitting"
          class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-white bg-red-600 border border-transparent rounded hover:bg-red-700 disabled:bg-gray-300 disabled:text-gray-500 disabled:hover:bg-gray-300 disabled:cursor-not-allowed"
        >
          <i v-if="submitting" class="fa-solid fa-circle-notch fa-spin text-[11px]"></i>
          {{ submitting ? 'Deleting...' : 'Delete version' }}
        </button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'DeleteVersionModal',
  props: {
    isVisible: { type: Boolean, default: false },
    version: { type: String, default: '' },
    submitting: { type: Boolean, default: false },
  },
  data() {
    return { deleteNote: '', textareaKey: 0 }
  },
  computed: {
    modalVisible: {
      get() { return this.isVisible },
      set(v) { this.$emit('update:isVisible', v) },
    },
  },
  watch: {
    isVisible(v) {
      if (v) {
        this.deleteNote = ''
        this.textareaKey += 1
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit('update:isVisible', false)
      this.$emit('cancel')
    },
    handleSubmit() {
      this.$emit('confirm', { deleteNote: this.deleteNote })
    },
  },
}
</script>
